import { render } from "./AllDepartmentUser.vue?vue&type=template&id=3085c678&scoped=true"
import script from "./AllDepartmentUser.vue?vue&type=script&lang=js"
export * from "./AllDepartmentUser.vue?vue&type=script&lang=js"

import "./AllDepartmentUser.vue?vue&type=style&index=0&id=3085c678&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3085c678"]])

export default __exports__